import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useFetch } from "../hooks/useFetch";
import { StudentCardProps } from "./CommonStudentCard";

import peopleIcon from "../images/user-icon3.svg"
import learnIcon from "../images/learn-icon.svg"
import gradIcon from "../images/grad-icon.svg"
import absentIcon from "../images/pause-icon.svg"
import maintainIcon from "../images/renew-icon.svg"
import dropoutIcon from "../images/close-icon.svg"

interface FilterSummaryProps {
    courseId: number;
    semesterId: number;
    total: number;
    setTotal: React.Dispatch<React.SetStateAction<number>>;
}

export default ({ courseId, semesterId, total, setTotal }: FilterSummaryProps) => {

    const [cookies, setCookie] = useCookies(['user'])

    const [statusCount, setStatusCount] = useState({
        normal: 0,
        grad: 0,
        absent: 0,
        maintain: 0,
        dropout: 0
    })

    const { data: getStudentsData, status: getStudentsStatus, error: getStudentsError, loading: getStudentsLoading } = useFetch({
        url: `/Students?curriculumId=${courseId}&semesterId=${semesterId}`,
        method: 'get',
        headers: {
            'Authorization': `Bearer ${cookies?.user?.token}`
        }
    }, courseId, semesterId)

    useEffect(() => {
        if (getStudentsData) {
            setTotal(getStudentsData.length)
            setStatusCount(countStudentStatus(getStudentsData))
        } else {
            setTotal(0)
            setStatusCount({
                normal: 0,
                grad: 0,
                absent: 0,
                maintain: 0,
                dropout: 0
            })
        }
    }, [getStudentsData])

    useEffect(() => {
        if (getStudentsError) {
            //console.log("GET STUDENTS ERROR:", getStudentsError)
            if (getStudentsStatus === 401) {
                //console.log("UNAUTHORIZED")
            } else if (getStudentsStatus === 404) {
                //console.log("NOT FOUND")
                setTotal(0)
                setStatusCount({
                    normal: 0,
                    grad: 0,
                    absent: 0,
                    maintain: 0,
                    dropout: 0
                })
            }
        }
    }, [getStudentsError])

    function countStudentStatus(students: StudentCardProps[]) {
        let normal = 0
        let grad = 0
        let absent = 0
        let maintain = 0
        let dropout = 0

        students.forEach((student: StudentCardProps) => {
            switch (student.studentStatusId) {
                case 1:
                    normal++
                    break;
                case 2:
                    grad++
                    break;
                case 3:
                    absent++
                    break;
                case 4:
                    maintain++
                    break;
                case 5:
                    dropout++
                    break;
                default:
                    break;
            }
        })
        return { normal, grad, absent, maintain, dropout }
    }

    return (
        <>
            <div className="CourseFilter-course-info">
                <div className="flex gap-dot25">
                    <img src={peopleIcon} alt="people" />
                    <p>จำนวนนิสิต {total} คน</p>
                    <span>&nbsp;&nbsp;&nbsp;─&nbsp;&nbsp;&nbsp;</span>
                </div>
                <div className="flex gap-dot25">
                    <img src={learnIcon} alt="people" />
                    <p>กำลังศึกษา {statusCount.normal} คน</p>
                </div>
                <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                <div className="flex gap-dot25">
                    <img src={gradIcon} alt="people" />
                    <p>สำเร็จการศึกษา {statusCount.grad} คน</p>
                </div>
                <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                <div className="flex gap-dot25">
                    <img src={absentIcon} alt="people" />
                    <p>ลาพักการศึกษา {statusCount.absent} คน</p>
                </div>
                <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                <div className="flex gap-dot25">
                    <img src={maintainIcon} alt="people" />
                    <p>รักษาสถานภาพนิสิต {statusCount.maintain} คน</p>
                </div>
                <span>&nbsp;&nbsp;•&nbsp;&nbsp;</span>
                <div className="flex gap-dot25">
                    <img src={dropoutIcon} alt="people" />
                    <p>พ้นสถานภาพนิสิต {statusCount.dropout} คน</p>
                </div>
            </div>
        </>
    )
}